import { Route, Routes } from "react-router-dom";

import { Patient } from "@/Common/Models/Patient/Patient";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";
import { PrescriptionRenewalsViewMedicationHistory } from "./PrescriptionRenewalsViewMedicationHistory";
import { PrescriptionRenewalsViewRenewMedication } from "./PrescriptionRenewalsViewRenewMedication";
import { PrescriptionRenewalsViewResults } from "./PrescriptionRenewalsViewResults";

interface PrescriptionRenewalsViewRoutesProps {
    prescriptionRenewalId: string;
    patientSummary: IPatientMedicalSummaryModel;
    cleanPatientSummary: IPatientMedicalSummaryModel;
    patientProfile: Patient;
    refreshPatientData: () => Promise<void>;
}

function PrescriptionRenewalsViewRoutes(props: PrescriptionRenewalsViewRoutesProps): JSX.Element {
    return (
        <>
            <Routes>
                <Route
                    path="renewMedication"
                    element={(
                        <PrescriptionRenewalsViewRenewMedication
                            prescriptionRenewalId={props.prescriptionRenewalId}
                            patientSummary={props.patientSummary}
                            patientProfile={props.patientProfile}
                        />
                    )}
                />
                <Route
                    path="medicationHistory"
                    element={(
                        <PrescriptionRenewalsViewMedicationHistory
                            prescriptionRenewalId={props.prescriptionRenewalId}
                            patientSummary={props.cleanPatientSummary}
                            patientProfile={props.patientProfile}
                            refreshPatientData={async () => await props.refreshPatientData()}
                        />
                    )}
                />
                <Route
                    path="results"
                    element={(
                        <PrescriptionRenewalsViewResults
                            patientSummary={props.patientSummary}
                            patientProfile={props.patientProfile}
                        />
                    )}
                />
            </Routes>
        </>
    );
}

export { PrescriptionRenewalsViewRoutes };
